import * as React from "react";
import { Route, RouteComponentProps, Switch } from "react-router-dom";
import { JobList } from "../jobs/JobList";
import { JobQueueMap } from "../jobs/JobQueueMap";
import { JobQueues } from "../jobs/job-queues/JobQueues";
import { WeekendRunMonitoring } from "../operations/WeekendRunMonitoring";
import { NotFound, Unauthorized } from "../shared/ErrorPages";
import { Roles, UserContext } from "../user";
import { OperationsDashboard } from "./Dashboard";
import { FeatureFlagContext, Features } from "../feature-flags";

interface OperationsMatchRouteProps {
  clientId?: string;
  userId?: string;
}

type Props = RouteComponentProps<OperationsMatchRouteProps>;

export const OperationsRouter: React.FC<React.PropsWithChildren<Props>> = (props: Props) => {
  const user = React.useContext(UserContext);
  const featureFlags = React.useContext(FeatureFlagContext).enabledFeatureFlags;

  return (
    <Switch>
      <Route exact={true} path={`${props.match.url}/dashboard`} component={OperationsDashboard} />
      <Route exact={true} path={`${props.match.url}/jobs`} component={JobList} />
      {
        featureFlags.has(Features.OPERATIONS_JOB_QUEUES_PAGE) ?
          (<Route exact={true} path={`${props.match.url}/jobqueues`} component={JobQueues} />) : null
      }
      <Route exact={true} path={`${props.match.url}/jobqueuemap`} component={JobQueueMap} />
      <Route
        exact={true}
        path={`${props.match.url}/weekendrunmonitoring`}
        render={() => (
          user && (user.roles.includes(Roles.OPERATIONS_USER) || user.roles.includes(Roles.OPERATIONS_ADMIN) )? (
            <WeekendRunMonitoring />
          ) : (
            <Unauthorized />
          )
        )}
      />
      <Route component={NotFound} />
    </Switch>
  );
}
